// extracted by mini-css-extract-plugin
export default {"cardTrigger":"_4giPPk3kRido9OLIeXWS4Q=="};